@let orderItem = item();

<div class="relative bg-gray-50 p-6">
  @if (count() > 1) {
    <div
      class="absolute top-0 left-0 flex size-6 items-center justify-center bg-gray-300 text-sm">
      {{ index() + 1 }}.
    </div>
  }

  <div class="flex items-start gap-3">
    @if (isNotNil(orderItem.featuredFile)) {
      <div>
        <app-image-thumbnail size="md">
          <img
            [alt]="orderItem.featuredFile.alt"
            [fill]="true"
            [ngSrc]="orderItem.featuredFile.url" />
        </app-image-thumbnail>
      </div>
    }

    <div class="flex flex-1 flex-col gap-4">
      <div
        class="flex flex-1 flex-col gap-3 xl:flex-row xl:items-baseline xl:justify-between">
        <div class="flex items-center gap-3">
          <div class="flex flex-col">
            <div class="font-bold">{{ orderItem.name }}</div>

            @if (isNotNil(orderItem.subName)) {
              <div class="text-sm">{{ orderItem.subName }}</div>
            }
          </div>

          <div class="flex items-center gap-1">
            @if (isNil(orderItem.refundSummary)) {
              <div class="text-xs">x</div>
              <div class="text-xs">
                <app-number
                  [value]="orderItem.quantity"
                  unit="szt." />
              </div>
            } @else {
              <app-refunded-quantity
                [currentQuantity]="orderItem.refundSummary.currentQuantity"
                [originalQuantity]="orderItem.refundSummary.originalQuantity"
                [refundedQuantity]="orderItem.refundSummary.refundedQuantity" />
            }
          </div>
        </div>

        <div class="ms-auto flex items-center font-bold">
          @if (isNil(orderItem.refundSummary)) {
            <app-currency [amount]="orderItem.price" />
          } @else {
            <app-refunded-price
              [refundedPrice]="orderItem.refundSummary.refundedPrice"
              [originalPrice]="orderItem.refundSummary.originalPrice"
              [currentPrice]="orderItem.refundSummary.currentPrice" />
          }
        </div>
      </div>

      @if (orderItem.componentGroups.length) {
        <app-admin-order-item-component-groups
          [groups]="orderItem.componentGroups" />
      }
    </div>
  </div>
</div>
